/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { FETCH_CONTRACT_COMMISIONINGS_REQUEST, success, failure } from './action';

const fetchContractCommisionings = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(FETCH_CONTRACT_COMMISIONINGS_REQUEST)
    .map(({ payload: { params } }) => params)
    .mergeMap((params) =>
      AjaxRequest.open(
        'get',
        `/admin/contractcustom/contracts/${params.id}/commissioning?contractPaymentDate=${params.paymentDate}`,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(fetchContractCommisionings);
